import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { HighchartsChartModule } from 'highcharts-angular';

import { MentionModule } from 'angular-mentions';

import { QuillModule } from 'ngx-quill';

import { ToastrModule } from 'ngx-toastr';

import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
// import { DragDropModule } from '@angular/cdk/drag-drop';


import { ProfileComponent } from './profile/profile.component';

import { MatTooltipModule } from '@angular/material/tooltip';

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { AngularEditorModule } from '@kolkov/angular-editor';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SideNavComponent } from './side-nav/side-nav.component';
import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { ApiContractComponent } from './api-contract/api-contract.component';
import { FooterComponent } from './footer/footer.component';
import { LoaderComponent } from './loader/loader.component';
import { AdvisorProfileComponent } from './advisor-profile/advisor-profile.component';
// import { AdvisorProfilePerformanceComponent } from './advisor-profile/advisor-profile-performance/advisor-profile-performance.component';
import { ClientProfileComponent } from './client-profile/client-profile.component';
import { StagingClientProfileComponent } from './staging-client-profile/staging-client-profile.component';
import { ProspectProfileComponent } from './prospect-profile/prospect-profile.component';
import { AdvisorChatComponent } from './advisor-chat/advisor-chat.component';
import { EventCalendarComponent } from './event-calendar/event-calendar.component';
import { InitiativeManagementComponent } from './initiative-management/initiative-management.component';
import { InitiativeMilestonesComponent } from './initiative-management/initiative-milestones/initiative-milestones.component';
import { InitiativeMilestoneTasksComponent } from './initiative-management/initiative-milestone-tasks/initiative-milestone-tasks.component';
import { InitiativeMilestoneSubTasksComponent } from './initiative-management/initiative-milestone-sub-tasks/initiative-milestone-sub-tasks.component';
import { TextareaTaggingComponent } from './textarea-tagging/textarea-tagging.component';
import { AdvMgrPerfComponent } from './advisor-profile/adv-mgr-perf/adv-mgr-perf.component';
import { SendFeedbackComponent } from './send-feedback/send-feedback.component';
import { ActionItemsActivitiesComponent } from './action-items-activities/action-items-activities.component';
import { ActivitiesComponent } from './activities/activities.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ColumnResizableDirective } from 'src/app/directives/column-resizable.directive';
import { OppDifferentialAnalysisComponent } from './opp-differential-analysis/opp-differential-analysis.component';
import { StageProcessComponent } from './stage-process/stage-process.component';
import { StageProcessStepperComponent } from './stage-process/stage-process-stepper/stage-process-stepper.component';
import { OpportunityAnalysisComponent } from './stage-process/opportunity-analysis/opportunity-analysis.component';
import { RetentionAnalysisComponent } from './stage-process/retention-analysis/retention-analysis.component';
import { LeadsAnalysisComponent } from './stage-process/leads-analysis/leads-analysis.component';
import { StageProcessViewComponent } from './stage-process/stage-process-view/stage-process-view.component';
import { OppAnalysisComponent } from './opp-analysis/opp-analysis.component';
import { DepositAnalysisComponent } from './stage-process/deposit-analysis/deposit-analysis.component';
import { AiAdvisorAssistantComponent } from './ai-advisor-assistant/ai-advisor-assistant.component';
import { AssistantAssignedClientsComponent } from './ai-advisor-assistant/assistant-assigned-clients/assistant-assigned-clients.component';
import { AssistantUnassignedClientsComponent } from './ai-advisor-assistant/assistant-unassigned-clients/assistant-unassigned-clients.component';
import { AssistantDifferentiatorComponent } from './ai-advisor-assistant/assistant-differentiator/assistant-differentiator.component';
import { NonDepositAnalysisComponent } from './stage-process/non-deposit-analysis/non-deposit-analysis.component';
import { DepositsOverviewComponent } from './stage-process/deposits-overview/deposits-overview.component';
import { CustomerProfileComponent } from './customer-profile/customer-profile.component';
import { ActivityDetailsComponent } from './activities/activity-details/activity-details.component';
import { LeadProfileComponent } from './lead-profile/lead-profile.component';
import { ActionItemsComponent } from './action-items/action-items.component';
import { ActivityTableComponent } from './activity-table/activity-table.component';
import { ActivityTemplateComponent } from './activity-table/activity-template/activity-template.component';
import { StageProcessAnalysisComponent } from './stage-process/stage-process-analysis/stage-process-analysis.component';
import { AdvisorProfileDetailsComponent } from './advisor-profile-details/advisor-profile-details.component';
import { AdvisorProfileSalesHistoryComponent } from './advisor-profile-details/advisor-profile-sales-history/advisor-profile-sales-history.component';
import { ViewCoachingPlansComponent } from './view-coaching-plans/view-coaching-plans.component';
import { AdvisorSalesDashboardComponent } from './advisor-sales-dashboard/advisor-sales-dashboard.component';
import { PrivacyPoliciesComponent } from './privacy-policies/privacy-policies.component';
import { TermsUseComponent } from './terms-use/terms-use.component';
import { SupportUrlComponent } from './support-url/support-url.component';
import { DocumentationUrlComponent } from './documentation-url/documentation-url.component';
import { GlobalMessageComponent } from './global-message/global-message.component';
import { NoInternetComponent } from './no-internet/no-internet.component';
import { EmailAnalyticsComponent } from './email-analytics/email-analytics.component';
import { ClientOperationsComponent } from './operations/client-operations/client-operations.component';
import { ProspectOperationsComponent } from './operations/prospect-operations/prospect-operations.component';
import { BeneficiaryOperationsComponent } from './operations/beneficiary-operations/beneficiary-operations.component';
import { TrustedContactOperationsComponent } from './operations/trusted-contact-operations/trusted-contact-operations.component';
import { BankCustomerProfileComponent } from './bank-customer-profile/bank-customer-profile.component';
import { BankCustomerOperationsComponent } from './operations/bank-customer-operations/bank-customer-operations.component';
import { FormatPhoneNumberDirective } from 'src/app/directives/format-phone-number/format-phone-number.directive';
import { AdvisorOperationsComponent } from './operations/advisor-operations/advisor-operations.component';
import { AgiClientsComponent } from './ai-advisor-assistant/agi-clients/agi-clients.component';
import { AgiProspectsComponent } from './ai-advisor-assistant/agi-prospects/agi-prospects.component';
import { RmClientDetailsComponent } from './operations/rm-client-details/rm-client-details.component';
import { RmCustomerProfileComponent } from './rm-customer-profile/rm-customer-profile.component';
import { AdvisorBookOptimiseComponent } from './advisor-book-optimise/advisor-book-optimise.component';
import { AdvisorViewOptimisedRecommentaionsComponent } from './advisor-book-optimise/advisor-view-optimised-recommentaions/advisor-view-optimised-recommentaions.component';
import { ExternalFileUploadComponent } from './external-file-upload/external-file-upload.component';
import { ActivityTemplateV2Component } from './activity-table/activity-template-v2/activity-template-v2.component';
import { IndividualActivityDetailsComponent } from './individual-activity-details/individual-activity-details.component';
import { AgentOneViewComponent } from './stage-process/agent-one-view/agent-one-view.component';
import { AgentThreeViewComponent } from './stage-process/agent-three-view/agent-three-view.component';
import { AgentFourViewComponent } from './stage-process/agent-four-view/agent-four-view.component';
import { AgenticFlowComponent } from './stage-process/agentic-flow/agentic-flow.component';
import { AiActivityTemplateComponent } from './activity-table/ai-activity-template/ai-activity-template.component';
import { GlobalPerformanceComponent } from './global-performance/global-performance.component';
import { ExternalMeetingSchedulerComponent } from './external-meeting-scheduler/external-meeting-scheduler.component';
import { AdvisorTeamsComponent } from './advisor-teams/advisor-teams.component';
import { NewActionItemsComponent } from './new-action-items/new-action-items.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { CLevelClientsComponent } from './c-level-clients/c-level-clients.component';
import { AiGovernanceDashboardComponent } from './ai-governance-dashboard/ai-governance-dashboard.component';
import { OppAnalysisV2Component } from './opp-analysis-v2/opp-analysis-v2.component';
import { StageProcessAnalysisV2Component } from './stage-process/stage-process-analysis-v2/stage-process-analysis-v2.component';
import { IndividualNewActivityComponent } from './individual-new-activity/individual-new-activity.component';
import { PortfolioClientSegmentationV2Component } from './portfolio-client-segmentation-v2/portfolio-client-segmentation-v2.component';


@NgModule({
    declarations: [
        FooterComponent,
        ProfileComponent,
        SideNavComponent,
        LoginComponent,
        ForgotPasswordComponent,
        ChangePasswordComponent,
        ApiContractComponent,
        LoaderComponent,
        AdvisorProfileComponent,
        // AdvisorProfilePerformanceComponent,
        AdvMgrPerfComponent,
        ClientProfileComponent,
        StagingClientProfileComponent,
        ProspectProfileComponent,
        AdvisorChatComponent,
        EventCalendarComponent,
        InitiativeManagementComponent,
        InitiativeMilestonesComponent,
        InitiativeMilestoneTasksComponent,
        InitiativeMilestoneSubTasksComponent,
        TextareaTaggingComponent,
        SendFeedbackComponent,
        ActionItemsActivitiesComponent,
        ActivitiesComponent,
        OppDifferentialAnalysisComponent,
        StageProcessComponent,
        StageProcessStepperComponent,
        OpportunityAnalysisComponent,
        RetentionAnalysisComponent,
        LeadsAnalysisComponent,
        StageProcessViewComponent,
        ColumnResizableDirective,
        FormatPhoneNumberDirective,
        OppAnalysisComponent,
        DepositAnalysisComponent,
        NonDepositAnalysisComponent,
        DepositsOverviewComponent,
        AiAdvisorAssistantComponent,
        AssistantAssignedClientsComponent,
        AssistantUnassignedClientsComponent,
        AssistantDifferentiatorComponent,
        CustomerProfileComponent,
        LeadProfileComponent,
        ActivityDetailsComponent,
        ActionItemsComponent,
        ActivityTableComponent,
        ActivityTemplateComponent,
        StageProcessAnalysisComponent,
        AdvisorProfileDetailsComponent,
        AdvisorProfileSalesHistoryComponent,
        ViewCoachingPlansComponent,
        AdvisorSalesDashboardComponent,
        PrivacyPoliciesComponent,
        TermsUseComponent,
        SupportUrlComponent,
        DocumentationUrlComponent,
        GlobalMessageComponent,
        NoInternetComponent,
        EmailAnalyticsComponent,
        ClientOperationsComponent,
        ProspectOperationsComponent,
        BeneficiaryOperationsComponent,
        TrustedContactOperationsComponent,
        BankCustomerProfileComponent,
        BankCustomerOperationsComponent,
        AdvisorOperationsComponent,
        AgiClientsComponent,
        AgiProspectsComponent,
        RmClientDetailsComponent,
        RmCustomerProfileComponent,
        AdvisorBookOptimiseComponent,
        AdvisorViewOptimisedRecommentaionsComponent,
        ExternalFileUploadComponent,
        ActivityTemplateV2Component,
        IndividualActivityDetailsComponent,
        AgentOneViewComponent,
        AgentThreeViewComponent,
        AgentFourViewComponent,
        AgenticFlowComponent,
        AiActivityTemplateComponent,
        GlobalPerformanceComponent,
        ExternalMeetingSchedulerComponent,
        AdvisorTeamsComponent,
        NewActionItemsComponent,
        NotificationsComponent,
        CLevelClientsComponent,
        AiGovernanceDashboardComponent,        
        OppAnalysisV2Component,
        StageProcessAnalysisV2Component,
        IndividualNewActivityComponent,
        PortfolioClientSegmentationV2Component
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MentionModule,
        ToastrModule.forRoot(),
        BsDatepickerModule.forRoot(),
        MatSelectModule,
        MatTableModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatDialogModule,
        MatTooltipModule,
        MatInputModule,
        MatMenuModule,
        MatRadioModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatChipsModule,
        MatIconModule,
        // DragDropModule,
        NgbModalModule,
        NgxPaginationModule,
        NgxSpinnerModule,
        SlickCarouselModule,
        HighchartsChartModule,
        QuillModule.forRoot(),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        SlickCarouselModule,
        HighchartsChartModule,
        Ng2SearchPipeModule,

        AngularEditorModule,
    ],
    exports: [
        ReactiveFormsModule,
        FormsModule,
        MentionModule,
        MatSelectModule,
        MatTableModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatDialogModule,
        MatTooltipModule,
        MatInputModule,
        MatMenuModule,
        MatRadioModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatChipsModule,
        MatIconModule,
        // DragDropModule,
        NgxPaginationModule,

        AngularEditorModule,


        SlickCarouselModule,
        HighchartsChartModule,
        Ng2SearchPipeModule,
        FooterComponent,
        ProfileComponent,
        SideNavComponent,
        LoginComponent,
        ForgotPasswordComponent,
        ChangePasswordComponent,
        ApiContractComponent,
        LoaderComponent,
        AdvisorProfileComponent,
        // AdvisorProfilePerformanceComponent,
        AdvMgrPerfComponent,
        ClientProfileComponent,
        StagingClientProfileComponent,
        ProspectProfileComponent,
        AdvisorChatComponent,
        EventCalendarComponent,
        InitiativeManagementComponent,
        InitiativeMilestonesComponent,
        InitiativeMilestoneTasksComponent,
        InitiativeMilestoneSubTasksComponent,
        SendFeedbackComponent,
        TextareaTaggingComponent,
        ActionItemsActivitiesComponent,
        ActivitiesComponent,
        OppDifferentialAnalysisComponent,
        StageProcessComponent,
        StageProcessStepperComponent,
        OpportunityAnalysisComponent,
        RetentionAnalysisComponent,
        LeadsAnalysisComponent,
        StageProcessViewComponent,
        ColumnResizableDirective,
        FormatPhoneNumberDirective,
        OppAnalysisComponent,
        DepositAnalysisComponent,
        NonDepositAnalysisComponent,
        DepositsOverviewComponent,
        AiAdvisorAssistantComponent,
        AssistantAssignedClientsComponent,
        AssistantUnassignedClientsComponent,
        AssistantDifferentiatorComponent,
        CustomerProfileComponent,
        LeadProfileComponent,
        ActivityDetailsComponent,
        ActionItemsComponent,
        StageProcessAnalysisComponent,
        AdvisorProfileDetailsComponent,
        AdvisorProfileSalesHistoryComponent,
        ViewCoachingPlansComponent,
        AdvisorSalesDashboardComponent,
        PrivacyPoliciesComponent,
        TermsUseComponent,
        SupportUrlComponent,
        DocumentationUrlComponent,
        GlobalMessageComponent,
        NoInternetComponent,
        EmailAnalyticsComponent,
        ClientOperationsComponent,
        ProspectOperationsComponent,
        BeneficiaryOperationsComponent,
        TrustedContactOperationsComponent,
        BankCustomerProfileComponent,
        BankCustomerOperationsComponent,
        AdvisorOperationsComponent,
        AgiClientsComponent,
        AgiProspectsComponent,
        RmClientDetailsComponent,
        RmCustomerProfileComponent,
        AdvisorBookOptimiseComponent,
        AdvisorViewOptimisedRecommentaionsComponent,
        ExternalFileUploadComponent,
        ActivityTemplateV2Component,
        IndividualActivityDetailsComponent,
        AgentOneViewComponent,
        AgentThreeViewComponent,
        AgentFourViewComponent,
        AgenticFlowComponent,
        AiActivityTemplateComponent,
        GlobalPerformanceComponent,
        ExternalMeetingSchedulerComponent,
        AdvisorTeamsComponent,
        NewActionItemsComponent,
        NotificationsComponent,
        CLevelClientsComponent,
        AiGovernanceDashboardComponent,
        OppAnalysisV2Component,
        StageProcessAnalysisV2Component,
        IndividualNewActivityComponent,
        PortfolioClientSegmentationV2Component
    ],
})
export class SharedModule {}
